
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donatie-impreuna",
      function () {
        return require("private-next-pages/donatie-impreuna.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donatie-impreuna"])
      });
    }
  